import React from 'react';
import withIcon from '../utilities/withIcon'; 

const IconChartConfidenceLevel = () => {
  return (
    <g>
      <path
        d="M.75.015a.75.75 0 0 1 .743.648L1.5.765V14.5h13.752a.75.75 0 0 1 .743.648l.007.102a.75.75 0 0 1-.649.743l-.101.007H1.05a1.05 1.05 0 0 1-1.044-.936L0 14.95V.765a.75.75 0 0 1 .75-.75zM9.307 2.75l.563.004c1.382.058 2.07.823 2.798 2.661l.091.236.185.505.331.948.123.335.112.287.111.262c.468 1.058 1.002 1.609 1.593 1.745l.229.043c.36.097.6.445.55.822a.756.756 0 0 1-.848.646c-1.251-.163-2.217-1.086-2.91-2.654l-.064-.146-.062-.15-.124-.315-.132-.362-.33-.945-.16-.437-.187-.474-.18-.4c-.372-.766-.713-1.067-1.19-1.107l-.5-.004c-.536 0-.902.286-1.302 1.111l-.143.314-.074.175-.15.385-.16.437-.33.945-.132.362-.124.316c-.041.1-.083.198-.126.295-.693 1.568-1.659 2.49-2.91 2.654a.756.756 0 0 1-.848-.646.75.75 0 0 1 .55-.822l.101-.02c.643-.083 1.22-.635 1.72-1.768l.112-.262.112-.287.123-.335.33-.948.186-.505c.762-2.009 1.45-2.837 2.89-2.897l.176-.004z"
        
      />
    </g>
  );
};

export default withIcon(IconChartConfidenceLevel);
